export const GA_EVENTS = {
  ADSGRAM_ERROR: 'adsgram_error',
  UTM_PARAMS: 'utm_params',
  ADSGRAM_NOT_FOUND: 'adsgram_not_found',
  ADSGRAM_TOO_LONG_SESSION: 'adsgram_too_long_session',
  AD_ERROR: 'ad_error',
  MONETAG_NOT_PAID: 'ad_monetag_not_paid'

} as const

export type GAEvent = (typeof GA_EVENTS)[keyof typeof GA_EVENTS]
